import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ReportHeader from "../../../../Components/ReportHeader";
import { useGenerateReportMutation } from "../../../../features/Report/reportSlice";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js"; // Import html2pdf.js
import { jsPDF } from "jspdf"; // Import jsPDF
import "jspdf-autotable";
import { utils, writeFile } from "xlsx";

const SubReport1 = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const year = queryParams.get("year");
  const ReportType = queryParams.get("reportType");
  const GrpID = queryParams.get("groupId");
  const rows = Array(7).fill();
  const rowsCs = Array(9).fill();
  const [generateReport, { data: reportData, error, isLoading: reportLoading }] = useGenerateReportMutation();

  console.log("REPORT", reportData);

  const [cellWidth, setCellWidth] = React.useState("")


  useEffect(() => {
    setTimeout(() => {
      const cell = document.getElementById("wd0");
      console.log("CELLData", cell);
      if (cell) {
        const width = cell.offsetWidth;
        setCellWidth(width - 36);
        console.log("Cell Width:", width);
      }
    }, 1000);
  }, []);

  useEffect(() => {
    const handleReportGeneration = async () => {
      try {
        await generateReport({
          year,
          reportType: ReportType,
          groupId: GrpID,
        }).unwrap();
      } catch (err) {
        console.error("Error generating report:", err);
      }
    };
    handleReportGeneration();
  }, [year, ReportType, GrpID, generateReport]);

  if (reportLoading)
    return (
      <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "600", fontSize: "20px" }}>
        Loading...
      </div>
    );
  if (error)
    return (
      <div style={{ height: "100vh", overflow: "auto", display: "flex", justifyContent: "center", alignItems: "center" }} id='modal_body'>
        <div style={{ fontSize: "20px", fontWeight: "600", color: "#000000" }}>No Record Found !</div>
      </div>
    );

  const tableHeadReport1 = [
    { label: "" },
    { label: `2023 Total Procurement` },
    { label: "MBE" },
    { label: "WBE" },
    { label: "DVBE" },
    { label: "LGBTBE" },
    { label: "PDBE" },
    { label: "Other 8(a)*" },
    { label: "Total Supplier Diversity" },

    // createData("", "2023 Total Procurement", "MBE", "WBE", "DVBE", "LGBTBE", "PDBE", "Other 8(a)*", "Total Supplier Diversity")
  ];

  const handleText = (value, company) => {
    // console.log("COM", company)
    switch (value) {
      case 0:
        return company;
      case 1:
        return "Direct";
      case 2:
        return "";
      case 3:
        return "Subcontracting";
      case 4:
        return "";
      case 5:
        return "Combined";
      case 6:
      default:
        return "";
    }
  };
  const handleTextCell1 = (value, data) => {
    // console.log("COM", company)
    switch (value) {
      case 0:
        return "";
      case 1:
        return "";
      case 2:
        return "";
      case 3:
        return "";
      case 4:
        return "";
      case 5:
        return data?.TotalProcurement;
      case 6:
      default:
        return "100%";
    }
  };

  const handleVal = (value) => {
    // console.log("COM", company)
    switch (value) {
      case 0:
        return "Total";
      case 1:
        return reportData?.data?.reportDetails?.TotalProcurement || "";
      case 2:
        return reportData?.data?.reportDetails?.MBE || "";
      case 3:
        return reportData?.data?.reportDetails?.WBE || "";
      case 4:
        return reportData?.data?.reportDetails?.DVBE || "";
      case 5:
        return reportData?.data?.reportDetails?.LGBTBE || "";
      case 6:
        return reportData?.data?.reportDetails?.PDBE || "";
      case 7:
        return reportData?.data?.reportDetails?.OTHER8a || "";
      case 8:
        return reportData?.data?.reportDetails?.TotalSupplierDiversity || "";
      case 9:
      default:
        return "";
    }
  };
  const handleValPercent = (value) => {
    // console.log("COM", company)
    switch (value) {
      case 0:
        return "";
      case 1:
        return "100%";
      case 2:
        return reportData?.data?.reportDetails?.MBEPercentage || "";
      case 3:
        return reportData?.data?.reportDetails?.WBEPercentage || "";
      case 4:
        return reportData?.data?.reportDetails?.DVBEPercentage || "";
      case 5:
        return reportData?.data?.reportDetails?.LGBTBEPercentage || "";
      case 6:
        return reportData?.data?.reportDetails?.PDBEPercentage || "";
      case 7:
        return reportData?.data?.reportDetails?.OTHER8aPercentage || "";
      case 8:
        return reportData?.data?.reportDetails?.TotalSupplierDiversityPercentage || "";
      case 9:
      default:
        return "";
    }
  };
  const handleValSub = (value) => {
    // console.log("COM", company)
    switch (value) {
      case 0:
        return "Sub";
      case 1:
        return reportData?.data?.reportDetails?.TotalProcurement || "";
      case 2:
        return reportData?.data?.reportDetails?.SubMBE || "";
      case 3:
        return reportData?.data?.reportDetails?.SubWBE || "";
      case 4:
        return reportData?.data?.reportDetails?.SubDVBE || "";
      case 5:
        return reportData?.data?.reportDetails?.SubLGBTBE || "";
      case 6:
        return reportData?.data?.reportDetails?.SubPDBE || "";
      case 7:
        return reportData?.data?.reportDetails?.SubOTHER8a || "";
      case 8:
        return reportData?.data?.reportDetails?.SubTotalTotalSupplierDiversity || "";
      case 9:
      default:
        return "";
    }
  };
  const handleValPercentSub = (value) => {
    // console.log("COM", company)
    switch (value) {
      case 0:
        return "";
      case 1:
        return "100%";
      case 2:
        return reportData?.data?.reportDetails?.SubMBEPercentage || "";
      case 3:
        return reportData?.data?.reportDetails?.SubWBEPercentage || "";
      case 4:
        return reportData?.data?.reportDetails?.SubDVBEPercentage || "";
      case 5:
        return reportData?.data?.reportDetails?.SubLGBTBEPercentage || "";
      case 6:
        return reportData?.data?.reportDetails?.SubPDBEPercentage || "";
      case 7:
        return reportData?.data?.reportDetails?.SubOTHER8aPercentage || "";
      case 8:
        return reportData?.data?.reportDetails?.SubTotalTotalSupplierDiversityPercentage || "";
      case 9:
      default:
        return "";
    }
  };
  const handleCommonCell = (value, data, key) => {
    // console.log("COM", company)
    switch (value) {
      case 0:
        return "";
      case 1:
        return data?.[key]?.direct;
      case 2:
        return data?.[key]?.directPercentage;
      case 3:
        return data?.[key]?.subcontracting;
      case 4:
        return data?.[key]?.subcontractingPercentage;
      case 5:
        return data?.[key]?.combined;
      case 6:
      default:
        return data?.[key]?.combinedPercentage;
    }
  };

  const handleTitlevalue = () => {
    switch (ReportType) {
      case "Report_1a_Large":
        return "Table 1A"
      case "Report_1a_Small":
        return "Table 1B"
      case "Report_1a_CCA":
        return "Table 1C"
      case "Report_2a_TotalSpend":
        return "Table 2A"
      case "Report_2a_Subcontracting":
        return "Table 2B"
      case "Report_3a_Large":
        return "Table 3A"
      case "Report_3b_Small":
        return "Table 3B"
      case "Report_3c_Large":
        return "Table 3C"
      case "Report_3d_Small":
        return "Table 3D"
      case "Report_4a_Large":
        return "Table 4A"
      case "Report_4a_Small":
        return "Table 4B"
      case "Report_5a_DVBE":
        return "Table 5A"
      case "Report_5a_LGBTBE":
        return "Table 5B"
      default:
        return "Table";
    }
  }


  const generatePDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [420, 297]
    });

    const commonColumnWidth = 40;



    // Define the header function with title and description
    const addHeader = (doc) => {
      doc.setFontSize(24);
      doc.setTextColor(40);
      doc.text(handleTitlevalue(), 14, 10); // Title

      doc.setFontSize(16);
      doc.setTextColor(60);
      doc.text(
        handleTitle(),
        14,
        16,
        { maxWidth: 180 }
      ); // Description (wrapped text)

      doc.setLineWidth(0.5);
      // doc.line(10, 22, 200, 22); // Horizontal line
    };

    // Call the header function for the first page
    addHeader(doc);

    // Loop through `reportData` and create tables
    reportData?.data?.reportData?.forEach((itm, idx) => {
      const tableHead = [
        [
          "",
          `${year} Total Procurement`,
          "MBE",
          "WBE",
          "DVBE",
          "LGBTBE",
          "PDBE",
          "Other 8(a)*",
          "Total Supplier Diversity",
        ], // Replace with dynamic headers (tableHeadReport1)
      ];

      const tableBody = rows.map((row, ix) =>
        Array(9)
          .fill(null)
          .map((_, cellIndex) => {
            switch (cellIndex) {
              case 0:
                return handleText(ix, itm?.CompanyName); // Customize for the first cell
              case 1:
                return handleTextCell1(ix, itm);
              case 2:
                return handleCommonCell(ix, itm, "MBE");
              case 3:
                return handleCommonCell(ix, itm, "WBE");
              case 4:
                return handleCommonCell(ix, itm, "DVBE");
              case 5:
                return handleCommonCell(ix, itm, "LGBTBE");
              case 6:
                return handleCommonCell(ix, itm, "PDBE");
              case 7:
                return handleCommonCell(ix, itm, "OTHER_8a");
              case 8:
                return handleCommonCell(ix, itm, "TotalSupplierDiversity");
              default:
                return "";
            }
          })
      );

      // Customize table styles
      const tableOptions = {
        startY: idx === 0 ? 20 : doc.previousAutoTable.finalY + 20, // Position for multiple tables
        head: tableHead,
        body: tableBody,
        showHead: "firstPage",
        styles: {
          fontSize: 12,
          cellPadding: 4,
        },
        headStyles: {
          fillColor: [233, 248, 255], // Light blue background
          textColor: "#000",
          fontStyle: "bold",
        },
        bodyStyles: {
          textColor: "#1A1A1A",
        },
        columnStyles: {
          0: { cellWidth: commonColumnWidth },
          1: { cellWidth: commonColumnWidth },
          2: { cellWidth: commonColumnWidth },
          3: { cellWidth: commonColumnWidth },
          4: { cellWidth: commonColumnWidth },
          5: { cellWidth: commonColumnWidth },
          6: { cellWidth: commonColumnWidth },
          7: { cellWidth: commonColumnWidth },
          8: { cellWidth: commonColumnWidth },
        }
        // alternateRowStyles: {
        //     fillColor: [246, 246, 246], // Light gray
        // },
      };

      // Add table to PDF
      doc.autoTable(tableOptions);
    });

    // Add the first additional table
    if (rowsCs?.length > 0) {
      // First table with horizontal data
      const additionalTable1Body = [
        [...rowsCs.map((_, ix) => handleVal(ix))],
        [...rowsCs.map((_, ix) => handleValPercent(ix))],
        // ["Subcategory Total", ...rowsCs.map((_, ix) => handleValSub(ix))],
        // ["Subcategory Percent", ...rowsCs.map((_, ix) => handleValPercentSub(ix))],
      ];

      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 20, // Position the table below the last table
        body: additionalTable1Body,
        styles: {
          fontSize: 12,
          cellPadding: 4,
        },
        headStyles: {
          fillColor: [255, 255, 255], // White background
          textColor: "#000",
          fontStyle: "bold",
        },
        bodyStyles: {
          textColor: "#1A1A1A",
        },
        columnStyles: rowsCs.reduce((acc, _, idx) => {
          acc[idx] = { cellWidth: commonColumnWidth };
          return acc;
        }, {})
      });
    }

    // Second table with horizontal data
    if (rowsCs?.length > 0) {
      const additionalTable2Body = [
        // ["Subcategory Total", ...rowsCs.map((_, ix) => handleValSub(ix))],
        // ["Subcategory Percent", ...rowsCs.map((_, ix) => handleValPercentSub(ix))],
        [...rowsCs.map((_, ix) => handleValSub(ix))],
        [...rowsCs.map((_, ix) => handleValPercentSub(ix))],
      ];

      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 20, // Position the table below the last table
        body: additionalTable2Body,
        styles: {
          fontSize: 12,
          cellPadding: 4,
        },
        headStyles: {
          fillColor: [255, 255, 255], // White background
          textColor: "#000",
          fontStyle: "bold",
        },
        bodyStyles: {
          textColor: "#1A1A1A",
        },
        columnStyles: rowsCs.reduce((acc, _, idx) => {
          acc[idx] = { cellWidth: commonColumnWidth };
          return acc;
        }, {})
      });
    }

    // Save the PDF
    doc.save("Report.pdf");
  }

  const downloadCSV = () => {

    const title = handleTitlevalue(); // Your title here
    const description = handleTitle();
    const headers = tableHeadReport1.map((item) => item.label); // Assuming rows have headerName
    const csvRows = [];

    // Add headers to CSV
    csvRows.push(title);
    csvRows.push(description);
    csvRows.push(headers.join(","));

    // Helper to escape and pad CSV values
    const escapeAndPadValue = (value, columnWidths, index) => {
        const escapedValue = escapeCSVValue(value || ""); // Escape values for CSV
        const paddedValue = escapedValue.padEnd(columnWidths[index], " "); // Add padding
        return `"${paddedValue.trim()}"`; // Wrap in quotes for CSV format
    };

    // Escape special characters for CSV
    const escapeCSVValue = (value) => {
        if (!value) return "";
        return value.toString().replace(/"/g, '""'); // Escape double quotes for CSV
    };

    // Determine maximum width for each column based on data and headers
    const columnWidths = headers.map((_, index) => {
        const headerWidth = headers[index]?.length || 0;
        const maxDataWidth = Math.max(
            ...reportData?.data?.reportData?.map((itm) => {
                const rowValues = [
                    itm?.CompanyName || "",
                    itm?.MBE?.direct || "",
                    itm?.WBE?.direct || "",
                    itm?.DVBE?.direct || "",
                    itm?.LGBTBE?.direct || "",
                    itm?.PDBE?.direct || "",
                    itm?.OTHER_8a?.direct || "",
                    itm?.TotalSupplierDiversity?.direct || "",
                    itm?.TotalProcurement || "",
                ];
                return (rowValues[index]?.toString()?.length || 0);
            })
        );
        return Math.max(headerWidth, maxDataWidth); // Maximum width for each column
    });

    // Add rows data to CSV
    reportData?.data?.reportData?.forEach((itm) => {
        const row1 = [
            escapeAndPadValue(itm?.CompanyName, columnWidths, 0),
            escapeAndPadValue("", columnWidths, 1),
            escapeAndPadValue("", columnWidths, 2),
            escapeAndPadValue("", columnWidths, 3),
            escapeAndPadValue("", columnWidths, 4),
            escapeAndPadValue("", columnWidths, 5),
            escapeAndPadValue("", columnWidths, 6),
            escapeAndPadValue("", columnWidths, 7),
            escapeAndPadValue("", columnWidths, 8),
        ];
        const row2 = [
            escapeAndPadValue("Direct", columnWidths, 0),
            escapeAndPadValue("", columnWidths, 1),
            escapeAndPadValue(itm?.MBE?.direct, columnWidths, 2),
            escapeAndPadValue(itm?.WBE?.direct, columnWidths, 3),
            escapeAndPadValue(itm?.DVBE?.direct, columnWidths, 4),
            escapeAndPadValue(itm?.LGBTBE?.direct, columnWidths, 5),
            escapeAndPadValue(itm?.PDBE?.direct, columnWidths, 6),
            escapeAndPadValue(itm?.OTHER_8a?.direct, columnWidths, 7),
            escapeAndPadValue(itm?.TotalSupplierDiversity?.direct, columnWidths, 8),
        ];
        const row3 = [
            escapeAndPadValue("", columnWidths, 0),
            escapeAndPadValue("", columnWidths, 1),
            escapeAndPadValue(itm?.MBE?.directPercentage, columnWidths, 2),
            escapeAndPadValue(itm?.WBE?.directPercentage, columnWidths, 3),
            escapeAndPadValue(itm?.DVBE?.directPercentage, columnWidths, 4),
            escapeAndPadValue(itm?.LGBTBE?.directPercentage, columnWidths, 5),
            escapeAndPadValue(itm?.PDBE?.directPercentage, columnWidths, 6),
            escapeAndPadValue(itm?.OTHER_8a?.directPercentage, columnWidths, 7),
            escapeAndPadValue(itm?.TotalSupplierDiversity?.directPercentage, columnWidths, 8),
        ];
        const row4 = [
            escapeAndPadValue("Subcontracting", columnWidths, 0),
            escapeAndPadValue("", columnWidths, 1),
            escapeAndPadValue(itm?.MBE?.subcontracting, columnWidths, 2),
            escapeAndPadValue(itm?.WBE?.subcontracting, columnWidths, 3),
            escapeAndPadValue(itm?.DVBE?.subcontracting, columnWidths, 4),
            escapeAndPadValue(itm?.LGBTBE?.subcontracting, columnWidths, 5),
            escapeAndPadValue(itm?.PDBE?.subcontracting, columnWidths, 6),
            escapeAndPadValue(itm?.OTHER_8a?.subcontracting, columnWidths, 7),
            escapeAndPadValue(itm?.TotalSupplierDiversity?.subcontracting, columnWidths, 8),
        ];
        const row5 = [
            escapeAndPadValue("", columnWidths, 0),
            escapeAndPadValue("", columnWidths, 1),
            escapeAndPadValue(itm?.MBE?.subcontractingPercentage, columnWidths, 2),
            escapeAndPadValue(itm?.WBE?.subcontractingPercentage, columnWidths, 3),
            escapeAndPadValue(itm?.DVBE?.subcontractingPercentage, columnWidths, 4),
            escapeAndPadValue(itm?.LGBTBE?.subcontractingPercentage, columnWidths, 5),
            escapeAndPadValue(itm?.PDBE?.subcontractingPercentage, columnWidths, 6),
            escapeAndPadValue(itm?.OTHER_8a?.subcontractingPercentage, columnWidths, 7),
            escapeAndPadValue(itm?.TotalSupplierDiversity?.subcontractingPercentage, columnWidths, 8),
        ];
        const row6 = [
            escapeAndPadValue("Combined", columnWidths, 0),
            escapeAndPadValue(itm?.TotalProcurement, columnWidths, 1),
            escapeAndPadValue(itm?.MBE?.combined, columnWidths, 2),
            escapeAndPadValue(itm?.WBE?.combined, columnWidths, 3),
            escapeAndPadValue(itm?.DVBE?.combined, columnWidths, 4),
            escapeAndPadValue(itm?.LGBTBE?.combined, columnWidths, 5),
            escapeAndPadValue(itm?.PDBE?.combined, columnWidths, 6),
            escapeAndPadValue(itm?.OTHER_8a?.combined, columnWidths, 7),
            escapeAndPadValue(itm?.TotalSupplierDiversity?.combined, columnWidths, 8),
        ];
        const row7 = [
            escapeAndPadValue("", columnWidths, 0),
            escapeAndPadValue("100%", columnWidths, 1),
            escapeAndPadValue(itm?.MBE?.combinedPercentage, columnWidths, 2),
            escapeAndPadValue(itm?.WBE?.combinedPercentage, columnWidths, 3),
            escapeAndPadValue(itm?.DVBE?.combinedPercentage, columnWidths, 4),
            escapeAndPadValue(itm?.LGBTBE?.combinedPercentage, columnWidths, 5),
            escapeAndPadValue(itm?.PDBE?.combinedPercentage, columnWidths, 6),
            escapeAndPadValue(itm?.OTHER_8a?.combinedPercentage, columnWidths, 7),
            escapeAndPadValue(itm?.TotalSupplierDiversity?.combinedPercentage, columnWidths, 8),
        ];
        const row8 = [
            "", "", "", "", "", "", "", "", ""
        ];
        const row9 = [
            "", "", "", "", "", "", "", "", ""
        ];

        // Push each row into the csvRows array
        csvRows.push(row1.join(","));
        csvRows.push(row2.join(","));
        csvRows.push(row3.join(","));
        csvRows.push(row4.join(","));
        csvRows.push(row5.join(","));
        csvRows.push(row6.join(","));
        csvRows.push(row7.join(","));
        csvRows.push(row8.join(","));
        csvRows.push(row9.join(","));
    });


    // csvRows.push(""); // Add an empty line between tables
    // csvRows.push("Second Table"); // You can customize this as a section header
    csvRows.push(rowsCs?.map((itm, ix) => escapeAndPadValue(handleVal(ix), columnWidths, ix)).join(","));
    csvRows.push(rowsCs?.map((itm, ix) => escapeAndPadValue(handleValPercent(ix), columnWidths, ix)).join(","));
    // Add more rows if needed...

    // Add the third table (Third data section)
    csvRows.push(rowsCs?.map((itm, ix) => escapeAndPadValue(handleValSub(ix), columnWidths, ix)).join(","));
    csvRows.push(rowsCs?.map((itm, ix) => escapeAndPadValue(handleValPercentSub(ix), columnWidths, ix)).join(","));

    // Convert the CSV rows to a single string
    const csvContent = csvRows.join("\n");

    // Create a downloadable link for the CSV file
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "report.csv"; // You can customize the file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

  // // const generatePDF = () => {
  // //   const doc = new jsPDF({
  // //     orientation: "landscape",
  // //     unit: "mm",
  // //     format: [420, 297]
  // //   });

  // //   // Add a header to the PDF
  // //   const addHeader = (doc) => {
  // //     doc.setFontSize(24);
  // //     doc.setTextColor(40);
  // //     doc.text(handleTitlevalue(), 14, 10); // Title

  // //     doc.setFontSize(16);
  // //     doc.setTextColor(60);
  // //     doc.text(
  // //         handleTitle(),
  // //         14,
  // //         16,
  // //         { maxWidth: 180 }
  // //     ); // Description (wrapped text)

  // //     doc.setLineWidth(0.5);
  // //     // doc.line(10, 22, 200, 22); // Horizontal line
  // // };

  // // // Call the header function for the first page
  // // addHeader(doc);

  // //   // Loop through `reportData` and create tables
  // //   reportData?.data?.reportData?.forEach((itm, idx) => {
  // //     const tableHead = [
  // //       ["", `${year} Total Procurement`, "MBE", "WBE", "DVBE", "LGBTBE", "PDBE", "Other 8(a)*", "Total Supplier Diversity"], // Replace with dynamic headers (tableHeadReport1)
  // //     ];

  // //     const tableBody = rows.map((row, ix) =>
  // //       Array(9)
  // //         .fill(null)
  // //         .map((_, cellIndex) => {
  // //           switch (cellIndex) {
  // //             case 0:
  // //               return handleText(ix, itm?.CompanyName); // Customize for the first cell
  // //             case 1:
  // //               return handleTextCell1(ix, itm);
  // //             case 2:
  // //               return handleCommonCell(ix, itm, "MBE");
  // //             case 3:
  // //               return handleCommonCell(ix, itm, "WBE");
  // //             case 4:
  // //               return handleCommonCell(ix, itm, "DVBE");
  // //             case 5:
  // //               return handleCommonCell(ix, itm, "LGBTBE");
  // //             case 6:
  // //               return handleCommonCell(ix, itm, "PDBE");
  // //             case 7:
  // //               return handleCommonCell(ix, itm, "OTHER_8a");
  // //             case 8:
  // //               return handleCommonCell(ix, itm, "TotalSupplierDiversity");
  // //             default:
  // //               return "";
  // //           }
  // //         })
  // //     );

  // //     // Customize table styles
  // //     const tableOptions = {
  // //       startY: idx === 0 ? 20 : doc.previousAutoTable.finalY + 20, // Position for multiple tables
  // //       head: tableHead,
  // //       body: tableBody,
  // //       showHead: "firstPage",
  // //       styles: {
  // //         fontSize: 14,
  // //         cellPadding: 4,
  // //       },
  // //       headStyles: {
  // //         fillColor: [233, 248, 255], // Light blue background
  // //         textColor: "#000",
  // //         fontStyle: "bold",
  // //       },
  // //       bodyStyles: {
  // //         textColor: "#1A1A1A",
  // //       },
  // //       // alternateRowStyles: {
  // //       //     fillColor: [246, 246, 246], // Light gray
  // //       // },
  // //     };

  // //     // Add table to PDF
  // //     doc.autoTable(tableOptions);
  // //   });

  // //   // Add the first additional table
  // //   if (rowsCs?.length > 0) {
  // //     // First table with horizontal data
  // //     const additionalTable1Body = [
  // //       [...rowsCs.map((_, ix) => handleVal(ix))],
  // //       [...rowsCs.map((_, ix) => handleValPercent(ix))],
  // //       // ["Subcategory Total", ...rowsCs.map((_, ix) => handleValSub(ix))],
  // //       // ["Subcategory Percent", ...rowsCs.map((_, ix) => handleValPercentSub(ix))],
  // //     ];

  // //     doc.autoTable({
  // //       startY: doc.lastAutoTable.finalY + 20, // Position the table below the last table
  // //       body: additionalTable1Body,
  // //       styles: {
  // //         fontSize: 14,
  // //         cellPadding: 4,
  // //       },
  // //       headStyles: {
  // //         fillColor: [255, 255, 255], // White background
  // //         textColor: "#000",
  // //         fontStyle: "bold",
  // //       },
  // //       bodyStyles: {
  // //         textColor: "#1A1A1A",
  // //       },
  // //     });
  // //   }

  // //   // Second table with horizontal data
  // //   if (rowsCs?.length > 0) {
  // //     const additionalTable2Body = [
  // //       // ["Subcategory Total", ...rowsCs.map((_, ix) => handleValSub(ix))],
  // //       // ["Subcategory Percent", ...rowsCs.map((_, ix) => handleValPercentSub(ix))],
  // //       [...rowsCs.map((_, ix) => handleValSub(ix))],
  // //       [...rowsCs.map((_, ix) => handleValPercentSub(ix))],
  // //     ];

  // //     doc.autoTable({
  // //       startY: doc.lastAutoTable.finalY + 20, // Position the table below the last table
  // //       body: additionalTable2Body,
  // //       styles: {
  // //         fontSize: 14,
  // //         cellPadding: 4,
  // //       },
  // //       headStyles: {
  // //         fillColor: [255, 255, 255], // White background
  // //         textColor: "#000",
  // //         fontStyle: "bold",
  // //       },
  // //       bodyStyles: {
  // //         textColor: "#1A1A1A",
  // //       },
  // //     });
  // //   }

  // //   // Save the PDF
  // //   doc.save("Report.pdf");
  // // };

  // // const escapeCSVValue = (value) => {
  // //     if (value && value.toString().includes(",")) {
  // //         return `"${value}"`; // Wrap value in double quotes if it contains commas
  // //     }
  // //     return value || "";
  // // };
  // const downloadCSV = () => {
  //   const headers = tableHeadReport1.map((item) => item.label); // Assuming rows have headerName
  //   const csvRows = [];

  //   // Add headers to CSV
  //   csvRows.push(headers.join(","));

  //   // Helper to escape and pad CSV values
  //   const escapeAndPadValue = (value, columnWidths, index) => {
  //     const escapedValue = escapeCSVValue(value || ""); // Escape values for CSV
  //     const paddedValue = escapedValue.padEnd(columnWidths[index], " "); // Add padding
  //     return `"${paddedValue.trim()}"`; // Wrap in quotes for CSV format
  //   };

  //   // Escape special characters for CSV
  //   const escapeCSVValue = (value) => {
  //     if (!value) return "";
  //     return value.toString().replace(/"/g, '""'); // Escape double quotes for CSV
  //   };

  //   // Determine maximum width for each column based on data and headers
  //   const columnWidths = headers.map((_, index) => {
  //     const headerWidth = headers[index]?.length || 0;
  //     const maxDataWidth = Math.max(
  //       ...reportData?.data?.reportData?.map((itm) => {
  //         const rowValues = [
  //           itm?.CompanyName || "",
  //           itm?.MBE?.direct || "",
  //           itm?.WBE?.direct || "",
  //           itm?.DVBE?.direct || "",
  //           itm?.LGBTBE?.direct || "",
  //           itm?.PDBE?.direct || "",
  //           itm?.OTHER_8a?.direct || "",
  //           itm?.TotalSupplierDiversity?.direct || "",
  //           itm?.TotalProcurement || "",
  //         ];
  //         return rowValues[index]?.toString()?.length || 0;
  //       })
  //     );
  //     return Math.max(headerWidth, maxDataWidth); // Maximum width for each column
  //   });

  //   // Add rows data to CSV
  //   reportData?.data?.reportData?.forEach((itm) => {
  //     const row1 = [
  //       escapeAndPadValue(itm?.CompanyName, columnWidths, 0),
  //       escapeAndPadValue("", columnWidths, 1),
  //       escapeAndPadValue("", columnWidths, 2),
  //       escapeAndPadValue("", columnWidths, 3),
  //       escapeAndPadValue("", columnWidths, 4),
  //       escapeAndPadValue("", columnWidths, 5),
  //       escapeAndPadValue("", columnWidths, 6),
  //       escapeAndPadValue("", columnWidths, 7),
  //       escapeAndPadValue("", columnWidths, 8),
  //     ];
  //     const row2 = [
  //       escapeAndPadValue("Direct", columnWidths, 0),
  //       escapeAndPadValue("", columnWidths, 1),
  //       escapeAndPadValue(itm?.MBE?.direct, columnWidths, 2),
  //       escapeAndPadValue(itm?.WBE?.direct, columnWidths, 3),
  //       escapeAndPadValue(itm?.DVBE?.direct, columnWidths, 4),
  //       escapeAndPadValue(itm?.LGBTBE?.direct, columnWidths, 5),
  //       escapeAndPadValue(itm?.PDBE?.direct, columnWidths, 6),
  //       escapeAndPadValue(itm?.OTHER_8a?.direct, columnWidths, 7),
  //       escapeAndPadValue(itm?.TotalSupplierDiversity?.direct, columnWidths, 8),
  //     ];
  //     const row3 = [
  //       escapeAndPadValue("", columnWidths, 0),
  //       escapeAndPadValue("", columnWidths, 1),
  //       escapeAndPadValue(itm?.MBE?.directPercentage, columnWidths, 2),
  //       escapeAndPadValue(itm?.WBE?.directPercentage, columnWidths, 3),
  //       escapeAndPadValue(itm?.DVBE?.directPercentage, columnWidths, 4),
  //       escapeAndPadValue(itm?.LGBTBE?.directPercentage, columnWidths, 5),
  //       escapeAndPadValue(itm?.PDBE?.directPercentage, columnWidths, 6),
  //       escapeAndPadValue(itm?.OTHER_8a?.directPercentage, columnWidths, 7),
  //       escapeAndPadValue(itm?.TotalSupplierDiversity?.directPercentage, columnWidths, 8),
  //     ];
  //     const row4 = [
  //       escapeAndPadValue("Subcontracting", columnWidths, 0),
  //       escapeAndPadValue("", columnWidths, 1),
  //       escapeAndPadValue(itm?.MBE?.subcontracting, columnWidths, 2),
  //       escapeAndPadValue(itm?.WBE?.subcontracting, columnWidths, 3),
  //       escapeAndPadValue(itm?.DVBE?.subcontracting, columnWidths, 4),
  //       escapeAndPadValue(itm?.LGBTBE?.subcontracting, columnWidths, 5),
  //       escapeAndPadValue(itm?.PDBE?.subcontracting, columnWidths, 6),
  //       escapeAndPadValue(itm?.OTHER_8a?.subcontracting, columnWidths, 7),
  //       escapeAndPadValue(itm?.TotalSupplierDiversity?.subcontracting, columnWidths, 8),
  //     ];
  //     const row5 = [
  //       escapeAndPadValue("", columnWidths, 0),
  //       escapeAndPadValue("", columnWidths, 1),
  //       escapeAndPadValue(itm?.MBE?.subcontractingPercentage, columnWidths, 2),
  //       escapeAndPadValue(itm?.WBE?.subcontractingPercentage, columnWidths, 3),
  //       escapeAndPadValue(itm?.DVBE?.subcontractingPercentage, columnWidths, 4),
  //       escapeAndPadValue(itm?.LGBTBE?.subcontractingPercentage, columnWidths, 5),
  //       escapeAndPadValue(itm?.PDBE?.subcontractingPercentage, columnWidths, 6),
  //       escapeAndPadValue(itm?.OTHER_8a?.subcontractingPercentage, columnWidths, 7),
  //       escapeAndPadValue(itm?.TotalSupplierDiversity?.subcontractingPercentage, columnWidths, 8),
  //     ];
  //     const row6 = [
  //       escapeAndPadValue("Combined", columnWidths, 0),
  //       escapeAndPadValue(itm?.TotalProcurement, columnWidths, 1),
  //       escapeAndPadValue(itm?.MBE?.combined, columnWidths, 2),
  //       escapeAndPadValue(itm?.WBE?.combined, columnWidths, 3),
  //       escapeAndPadValue(itm?.DVBE?.combined, columnWidths, 4),
  //       escapeAndPadValue(itm?.LGBTBE?.combined, columnWidths, 5),
  //       escapeAndPadValue(itm?.PDBE?.combined, columnWidths, 6),
  //       escapeAndPadValue(itm?.OTHER_8a?.combined, columnWidths, 7),
  //       escapeAndPadValue(itm?.TotalSupplierDiversity?.combined, columnWidths, 8),
  //     ];
  //     const row7 = [
  //       escapeAndPadValue("", columnWidths, 0),
  //       escapeAndPadValue("100%", columnWidths, 1),
  //       escapeAndPadValue(itm?.MBE?.combinedPercentage, columnWidths, 2),
  //       escapeAndPadValue(itm?.WBE?.combinedPercentage, columnWidths, 3),
  //       escapeAndPadValue(itm?.DVBE?.combinedPercentage, columnWidths, 4),
  //       escapeAndPadValue(itm?.LGBTBE?.combinedPercentage, columnWidths, 5),
  //       escapeAndPadValue(itm?.PDBE?.combinedPercentage, columnWidths, 6),
  //       escapeAndPadValue(itm?.OTHER_8a?.combinedPercentage, columnWidths, 7),
  //       escapeAndPadValue(itm?.TotalSupplierDiversity?.combinedPercentage, columnWidths, 8),
  //     ];
  //     const row8 = ["", "", "", "", "", "", "", "", ""];
  //     const row9 = ["", "", "", "", "", "", "", "", ""];

  //     // Push each row into the csvRows array
  //     csvRows.push(row1.join(","));
  //     csvRows.push(row2.join(","));
  //     csvRows.push(row3.join(","));
  //     csvRows.push(row4.join(","));
  //     csvRows.push(row5.join(","));
  //     csvRows.push(row6.join(","));
  //     csvRows.push(row7.join(","));
  //     csvRows.push(row8.join(","));
  //     csvRows.push(row9.join(","));
  //   });

  //   // csvRows.push(""); // Add an empty line between tables
  //   // csvRows.push("Second Table"); // You can customize this as a section header
  //   csvRows.push(rowsCs?.map((itm, ix) => escapeAndPadValue(handleVal(ix), columnWidths, ix)).join(","));
  //   csvRows.push(rowsCs?.map((itm, ix) => escapeAndPadValue(handleValPercent(ix), columnWidths, ix)).join(","));
  //   // Add more rows if needed...

  //   // Add the third table (Third data section)
  //   // csvRows.push(""); // Add an empty line between tables
  //   // csvRows.push("Third Table"); // You can customize this as a section header
  //   csvRows.push(rowsCs?.map((itm, ix) => escapeAndPadValue(handleValSub(ix), columnWidths, ix)).join(","));
  //   csvRows.push(rowsCs?.map((itm, ix) => escapeAndPadValue(handleValPercentSub(ix), columnWidths, ix)).join(","));

  //   // Convert the CSV rows to a single string
  //   const csvContent = csvRows.join("\n");

  //   // Create a downloadable link for the CSV file
  //   const blob = new Blob([csvContent], { type: "text/csv" });
  //   const url = URL.createObjectURL(blob);
  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = "report.csv"; // You can customize the file name
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  // };

  const downloadExcel = () => {
    const headers = tableHeadReport1.map((item) => item.label); // Assuming rows have headerName
    const excelRows = [];

    // Add headers to Excel
    excelRows.push(headers);

    // Helper to escape and pad Excel values
    const escapeAndPadValue = (value, columnWidths, index) => {
      const escapedValue = escapeCSVValue(value || ""); // Escape values for CSV
      const paddedValue = escapedValue.padEnd(columnWidths[index], " "); // Add padding
      return `"${paddedValue.trim()}"`; // Wrap in quotes for Excel format
    };

    // Escape special characters for CSV
    const escapeCSVValue = (value) => {
      if (!value) return "";
      return value.toString().replace(/"/g, '""'); // Escape double quotes for CSV
    };

    // Determine maximum width for each column based on data and headers
    const columnWidths = headers.map((_, index) => {
      const headerWidth = headers[index]?.length || 0;
      const maxDataWidth = Math.max(
        ...reportData?.data?.reportData?.map((itm) => {
          const rowValues = [
            itm?.CompanyName || "",
            itm?.MBE?.direct || "",
            itm?.WBE?.direct || "",
            itm?.DVBE?.direct || "",
            itm?.LGBTBE?.direct || "",
            itm?.PDBE?.direct || "",
            itm?.OTHER_8a?.direct || "",
            itm?.TotalSupplierDiversity?.direct || "",
            itm?.TotalProcurement || "",
          ];
          return rowValues[index]?.toString()?.length || 0;
        })
      );
      return Math.max(headerWidth, maxDataWidth); // Maximum width for each column
    });

    // Add rows data to Excel
    reportData?.data?.reportData?.forEach((itm) => {
      const row1 = [itm?.CompanyName || "", "", "", "", "", "", "", "", ""];
      const row2 = [
        "Direct",
        "",
        itm?.MBE?.direct || "",
        itm?.WBE?.direct || "",
        itm?.DVBE?.direct || "",
        itm?.LGBTBE?.direct || "",
        itm?.PDBE?.direct || "",
        itm?.OTHER_8a?.direct || "",
        itm?.TotalSupplierDiversity?.direct || "",
      ];
      const row3 = [
        "",
        "",
        itm?.MBE?.directPercentage || "",
        itm?.WBE?.directPercentage || "",
        itm?.DVBE?.directPercentage || "",
        itm?.LGBTBE?.directPercentage || "",
        itm?.PDBE?.directPercentage || "",
        itm?.OTHER_8a?.directPercentage || "",
        itm?.TotalSupplierDiversity?.directPercentage || "",
      ];
      const row4 = [
        "Subcontracting",
        "",
        itm?.MBE?.subcontracting || "",
        itm?.WBE?.subcontracting || "",
        itm?.DVBE?.subcontracting || "",
        itm?.LGBTBE?.subcontracting || "",
        itm?.PDBE?.subcontracting || "",
        itm?.OTHER_8a?.subcontracting || "",
        itm?.TotalSupplierDiversity?.subcontracting || "",
      ];
      const row5 = [
        "",
        "",
        itm?.MBE?.subcontractingPercentage || "",
        itm?.WBE?.subcontractingPercentage || "",
        itm?.DVBE?.subcontractingPercentage || "",
        itm?.LGBTBE?.subcontractingPercentage || "",
        itm?.PDBE?.subcontractingPercentage || "",
        itm?.OTHER_8a?.subcontractingPercentage || "",
        itm?.TotalSupplierDiversity?.subcontractingPercentage || "",
      ];
      const row6 = [
        "Combined",
        itm?.TotalProcurement || "",
        itm?.MBE?.combined || "",
        itm?.WBE?.combined || "",
        itm?.DVBE?.combined || "",
        itm?.LGBTBE?.combined || "",
        itm?.PDBE?.combined || "",
        itm?.OTHER_8a?.combined || "",
        itm?.TotalSupplierDiversity?.combined || "",
      ];
      const row7 = [
        "",
        "100%",
        itm?.MBE?.combinedPercentage || "",
        itm?.WBE?.combinedPercentage || "",
        itm?.DVBE?.combinedPercentage || "",
        itm?.LGBTBE?.combinedPercentage || "",
        itm?.PDBE?.combinedPercentage || "",
        itm?.OTHER_8a?.combinedPercentage || "",
        itm?.TotalSupplierDiversity?.combinedPercentage || "",
      ];
      const row8 = ["", "", "", "", "", "", "", "", ""];
      const row9 = ["", "", "", "", "", "", "", "", ""];

      // Push each row into the excelRows array
      excelRows.push(row1);
      excelRows.push(row2);
      excelRows.push(row3);
      excelRows.push(row4);
      excelRows.push(row5);
      excelRows.push(row6);
      excelRows.push(row7);
      excelRows.push(row8);
      excelRows.push(row9);
    });

    // Add the second and third tables (Data section)
    excelRows.push(rowsCs?.map((itm, ix) => handleVal(ix)));
    excelRows.push(rowsCs?.map((itm, ix) => handleValPercent(ix)));
    excelRows.push(rowsCs?.map((itm, ix) => handleValSub(ix)));
    excelRows.push(rowsCs?.map((itm, ix) => handleValPercentSub(ix)));

    // Create a new worksheet
    const ws = utils.aoa_to_sheet(excelRows);

    // Apply styling to the header row (make it bold and change font size)
    for (let colIdx = 0; colIdx < excelRows[0].length; colIdx++) {
      const cellAddress = { r: 0, c: colIdx }; // Header row is the first row (r: 0)

      // Ensure the cell exists and apply bold font and font size 14
      if (!ws[cellAddress]) ws[cellAddress] = {};
      ws[cellAddress].s = {
        font: {
          bold: true, // Makes the font bold
          sz: 14, // Sets the font size to 14 (default is 11)
        },
      };
    }

    // Create a workbook with the worksheet
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Report");

    // Write the file to download
    writeFile(wb, "report.xlsx");
  };
  const downloadHandle = (val) => {
    console.log("VL", val);
    if (val === 1) {
      generatePDF();
    }
    if (val === 2) {
      downloadExcel();
    }
    if (val === 3) {
      downloadCSV();
    }
  };

  const handleTitle = () => {
    if (ReportType === "Report_1a_Small") {
      return "Supplier Diversity Results For Small Utilities";
    }
    if (ReportType === "Report_1a_Large") {
      return "Supplier Diversity Results For Large Utilities";
    }
    if (ReportType === "Report_1a_CCA") {
      return "CCA Supplier Diversity Results Of Goods & Services";
    }
  };

  return (
    <div id='report_generation'>
      <ReportHeader
        handleClick={reportData?.data?.reportData?.length < 1 ? () => { } : downloadHandle}
        title={handleTitle()}
        year={year}
        report={ReportType}
        logo={localStorage.getItem("logo")}
      />
      {reportData?.data?.reportData?.length < 1 ? (
        <div
          style={{ height: "calc(100vh - 225px)", overflow: "auto", display: "flex", justifyContent: "center", alignItems: "center" }}
          id='modal_body'>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#000000" }}>No Record Found !</div>
        </div>
      ) : (
        <div style={{ height: "calc(100vh - 225px)", overflow: "auto" }} id='modal_body'>
          {reportData?.data?.reportData?.map((itm, idx) => {
            return (
              <TableContainer component={Paper} sx={{ marginTop: idx > 0 ? "24px" : "0px" }}>
                {/* {console.log(data, "data")} */}
                <Table aria-label='customized table'>
                  <TableHead>
                    <TableRow>
                      {tableHeadReport1.map((header, id) => (
                        <TableCell
                          key={id}
                          id={`wd${id}`}
                          align='center'
                          style={{
                            background: id === 0 ? "#fff" : "#E9F8FF",
                            fontWeight: "500",
                            color: "#000000",
                            fontSize: "16px",
                            letterSpacing: "0.2px",
                            width: id === 1 ? "150px" : "100px"
                          }}>
                          {header.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* {data?.currentRows.map((row, id) => ( */}
                    {rows.map((item, ix) => {
                      {
                        /* console.log(itm?.companyName,itm,"CPP") */
                      }
                      return (
                        <TableRow
                          sx={{
                            height: "62px",
                          }}>
                          {Array(9) // Assuming there are 9 cells in each row
                            .fill(null)
                            .map((_, cellIndex) => {
                              // Handle cell-specific logic with a switch case
                              const cellContent = (() => {
                                switch (cellIndex) {
                                  case 0:
                                    return handleText(ix, itm?.CompanyName); // Customize for the first cell
                                  case 1:
                                    return handleTextCell1(ix, itm);
                                  case 2:
                                    return handleCommonCell(ix, itm, "MBE");
                                  case 3:
                                    return handleCommonCell(ix, itm, "WBE");
                                  case 4:
                                    return handleCommonCell(ix, itm, "DVBE");
                                  case 5:
                                    return handleCommonCell(ix, itm, "LGBTBE");
                                  case 6:
                                    return handleCommonCell(ix, itm, "PDBE");
                                  case 7:
                                    return handleCommonCell(ix, itm, "OTHER_8a");
                                  case 8:
                                    return handleCommonCell(ix, itm, "TotalSupplierDiversity");
                                  // Add more cases as needed
                                  default:
                                    return null; // Default for cells without specific logic
                                }
                              })();

                              // Additional cell styles based on `cellIndex`
                              const cellStyle = {
                                fontWeight: cellIndex === 0 ? "700" : "400",
                                fontSize: "14px",
                                color: "#1A1A1A",
                                textAlign: ix === 0 && cellIndex === 0 ? "left" : "right",
                                border: "1px solid #E6E6E6", // Add border to each cell
                                borderTop: ix === 0 && cellIndex === 0 ? "none" : "1px solid #E6E6E6", // Remove borderTop only for the first cell of the first row
                                backgroundColor: ix === 3 || ix === 4 ? "#F6F6F6" : "transparent", // Conditional background color
                              };

                              return (
                                <TableCell sx={cellStyle} key={cellIndex}>
                                  {cellContent}
                                </TableCell>
                              );
                            })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            );
          })}
          {reportData?.data?.reportData?.length > 0 && (
            <TableContainer component={Paper} sx={{ marginTop: "24px" }}>
              {/* {console.log(data, "data")} */}
              <Table aria-label='customized table'>
              <TableHead>
                    <TableRow>
                      {tableHeadReport1.map((header, id) => (
                        <TableCell
                          key={id}
                          id={`wd${id}`}
                          align='center'
                          style={{
                            background: id === 0 ? "#fff" : "#E9F8FF",
                            fontWeight: "500",
                            color: "#000000",
                            fontSize: "16px",
                            letterSpacing: "0.2px",
                            width: id === 1 ? "150px" : "100px"
                          }}>
                          {header.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                {/* <TableHead> */}
                <TableRow>
                  {rowsCs?.map((itm, ix) => {
                    return (
                      <TableCell
                        key={ix}
                        align='right'
                        style={{
                          background: "#fff",
                          fontWeight: "700",
                          color: "#000000",
                          fontSize: "12px",
                          letterSpacing: "0.2px",
                          border: "1px solid #E6E6E6",
                          width: ix === 0 ? cellWidth : "auto", // Same logic for second row
                          minWidth: ix === 0 ? cellWidth : "auto",
                          maxWidth: ix === 0 ? cellWidth : "none",
                        }}>
                        {handleVal(ix)}
                      </TableCell>
                    );
                  })}
                </TableRow>
                <TableRow>
                  {rowsCs?.map((itm, ix) => {
                    return (
                      <TableCell
                        key={ix}
                        align='right'
                        style={{
                          background: "#fff",
                          fontWeight: "700",
                          color: "#000000",
                          fontSize: "12px",
                          letterSpacing: "0.2px",
                          border: "1px solid #E6E6E6",
                          width: ix === 0 ? cellWidth : "auto", // Same logic for second row
                          minWidth: ix === 0 ? cellWidth : "auto",
                          maxWidth: ix === 0 ? cellWidth : "none",
                        }}>
                        {handleValPercent(ix)}
                      </TableCell>
                    );
                  })}
                </TableRow>
                {/* </TableHead> */}
              </Table>
            </TableContainer>
          )}
          {reportData?.data?.reportData?.length > 0 && (
            <TableContainer component={Paper} sx={{ marginTop: "24px" }}>
              {/* {console.log(data, "data")} */}
              <Table aria-label='customized table'>
              <TableHead>
                    <TableRow>
                      {tableHeadReport1.map((header, id) => (
                        <TableCell
                          key={id}
                          id={`wd${id}`}
                          align='center'
                          style={{
                            background: id === 0 ? "#fff" : "#E9F8FF",
                            fontWeight: "500",
                            color: "#000000",
                            fontSize: "16px",
                            letterSpacing: "0.2px",
                            width: id === 1 ? "150px" : "100px"
                          }}>
                          {header.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                {/* <TableHead> */}
                <TableRow>
                  {rowsCs?.map((itm, ix) => {
                    return (
                      <TableCell
                        key={ix}
                        align='right'
                        style={{
                          background: "#fff",
                          fontWeight: "700",
                          color: "#000000",
                          fontSize: "12px",
                          letterSpacing: "0.2px",
                          border: "1px solid #E6E6E6",
                          width: ix === 0 ? cellWidth : "auto", // Same logic for second row
                          minWidth: ix === 0 ? cellWidth : "auto",
                          maxWidth: ix === 0 ? cellWidth : "none",
                        }}>
                        {handleValSub(ix)}
                      </TableCell>
                    );
                  })}
                </TableRow>
                <TableRow>
                  {rowsCs?.map((itm, ix) => {
                    return (
                      <TableCell
                        key={ix}
                        align='right'
                        style={{
                          background: "#fff",
                          fontWeight: "700",
                          color: "#000000",
                          fontSize: "12px",
                          letterSpacing: "0.2px",
                          border: "1px solid #E6E6E6",
                          width: ix === 0 ? cellWidth : "auto", // Same logic for second row
                          minWidth: ix === 0 ? cellWidth : "auto",
                          maxWidth: ix === 0 ? cellWidth : "none",
                        }}>
                        {handleValPercentSub(ix)}
                      </TableCell>
                    );
                  })}
                </TableRow>
                {/* </TableHead> */}
              </Table>
            </TableContainer>
          )}
        </div>
      )}
    </div>
  );
};

export default SubReport1;
